export const DEBOUNCE_DELAY = 400;
export const DEFAULT_MIN_DATE_TIME = new Date("1/1/2000");
export const INVALID_DATE = "Invalid Date";
